import React, { ReactNode, RefObject } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import { I18n, Translate } from 'react-redux-i18n';
import { FORM_ERROR } from 'final-form';
import TextInput from '../../common/inputs/TextInput';
import Button from '../../common/Button';
import logo from '../../../img/createAccount/identifiants_connexion.svg';
import PasswordInput from '../../common/inputs/passwordInput/PasswordInput';
import { validationMap } from '../../../network/api/types/compte/RequirementType';
import activationApi from '../../../network/api/activationApi';
import { InscriptionDTO } from '../../../network/api/types/InscriptionDTO';
import { ActivationDTO } from '../../../network/api/types/activation/ActivationDTO';

type Props = {
  divRef: RefObject<HTMLDivElement>;
  update: (values) => void;
  suggestedPseudo: string;
  onChange: (index: number) => void;
  initial: InscriptionDTO | ActivationDTO;
};

type State = {
};

class ActivationPassword extends React.Component<Props, State> {
  state: State = {};

  handleEdit = async (values: { pseudo: string,
    password: string,
    confirmPassword: string }):
  Promise<{ [FORM_ERROR]: string }> => {
    try {
      return activationApi.isConnexionIdsValid(values)
        .then(() => this.props.update(values))
        .catch((err) => {
          if (typeof err.then === 'function') {
            return err.then((e) => ({ [FORM_ERROR]: e.fieldErrors[0].message }));
          }
          return null;
        });
      // const json = await
      // return { [FORM_ERROR]: 'fal fa-check' };
    } catch (err) {
      return { [FORM_ERROR]: 'fal fa-exclamation-circle' };
    }
  };

  render(): ReactNode {
    const { initial } = this.props;
    return (
      <div ref={this.props.divRef} className="account-activation-form-container">
        <div className="account-activation-col">
          <h3><Translate value="ACTIVATION.DEFINE_IDS" /></h3>
        </div>
        <div className="account-activation-col">
          <Form
            onSubmit={this.handleEdit}
            initialValues={initial}
            validate={(values) => {
              const errors = {
                pseudo: null,
                password: null,
                confirmPassword: null,
              };
              if (!validationMap.pseudoPattern(values.pseudo)) {
                errors.pseudo = I18n.t('VALIDATION.PSEUDO.LENGTH');
              }
              if (validationMap.pseudoNotIDNPattern(values.pseudo)) {
                errors.pseudo = I18n.t('VALIDATION.PSEUDO.IDN');
              }
              if (validationMap.pseudoNumericPattern(values.pseudo)) {
                errors.pseudo = I18n.t('VALIDATION.PSEUDO.PATTERN');
              }
              if (!errors.pseudo && !validationMap.all(values.password)) {
                errors.password = I18n.t('VALIDATION.PASSWORD.UNFIT');
              }
              if (!errors.pseudo && validationMap.all(values.password)
                && values.password !== values.confirmPassword) {
                errors.confirmPassword = I18n.t('VALIDATION.PASSWORD.CONFIRM_DIFFERENT');
              }
              if (!errors.pseudo && !errors.password && !errors.confirmPassword) {
                return {};
              }
              return errors;
            }}
            render={(
              {
                handleSubmit,
                submitError,
                submitting,
                values,
              },
            ) => (
              <form className="connection-information-form" onSubmit={handleSubmit}>
                <FormSpy
                  subscription={{ values: true, pristine: true, initialValues: true }}
                  onChange={(state) => {
                    if (state.values.pseudo !== state.initialValues.pseudo
                      || state.values.password !== state.initialValues.password
                        || state.values.confirmPassword !== state.initialValues.confirmPassword
                    ) {
                      this.props.onChange(1);
                    }
                  }}
                />
                {submitError && <div className="error">{submitError}</div>}
                <Field
                  name="pseudo"
                  component={TextInput}
                  placeholder={I18n.t('ACTIVATION.PSEUDO')}
                  type="text"
                  required
                />
                <div className="password-container">
                  <Field
                    name="password"
                    component={PasswordInput}
                    placeholder={I18n.t('ACTIVATION.PASSWORD')}
                    type="text"
                    withHelper
                    required
                  />
                  <Field
                    name="confirmPassword"
                    component={PasswordInput}
                    placeholder={I18n.t('ACTIVATION.CONFIRME')}
                    type="text"
                    required
                  />
                </div>
                <div className="button-container">
                  <Button
                    type="primary"
                    buttonType="submit"
                    i18nKey="actions.NEXT"
                    isLoading={submitting}
                    disabled={values.pseudo === null
                    || values.password === null || values.confirmPassword === null}
                  />
                </div>
              </form>
            )}
          />
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={logo} alt="logo" />
          </div>
          <Translate value="ACTIVATION.CONFIDENTIAL_IDS" />
        </div>
      </div>
    );
  }
}

export default ActivationPassword;
